const Legal = Vue.component('legal', {
    template: `
        <div>
            <div class="row title">
                <div class="col">
                    <h4>
                        {{ $language.familyNum.replace('[FAMILYNUMBER]', family) }}&nbsp;<i class="fas fa-angle-right"></i>&nbsp;{{ $language.legalStat }}
                    </h4>
                </div>
            </div>
            <div class="main" id="legal">
                <iframe @load="$store.commit('hideLoading');" :src="legalUrl" frameborder="0" width="100%" height="100%"></iframe>
            </div>
        </div>
    `,
    // props: ['family'],

    data: function() {
        return {

        };
    },
    computed: {
        family() {
            return this.$route.params.family;
        },
        legalUrl: function() {
            return setupPath + '../legal/public/index.php?id=' + this.family + '&page=index';
        }
    }
});
